import { HttpResponse } from 'msw';

import { dhcpExtendedBlock } from './dhcp-extended';

type LegacyBody = { command?: string; access?: string };

export function handleDhcpLegacy(
  body: LegacyBody,
): ReturnType<typeof HttpResponse.json> {
  const command = body.command ?? '';
  const access = body.access ?? 'get';

  switch (command) {
    case 'get vids':
      return HttpResponse.json(
        [
          { vid: 0, type: 'server' },
          { vid: 10, type: 'relay' },
        ],
        { status: 200 },
      );
    case 'set vids':
      return HttpResponse.json({ ok: true }, { status: 200 });
    case 'get subnet':
      return HttpResponse.json(
        [
          {
            ip: '192.168.1.0',
            mask: '255.255.255.0',
            leasetime: 3600,
            pool_start: '192.168.1.100',
            pool_end: '192.168.1.200',
            options: [],
          },
        ],
        { status: 200 },
      );
    case 'get cfg leases':
      return HttpResponse.json(
        [
          {
            ip: '192.168.1.101',
            type: 1,
            value: ['AA:BB:CC:DD:EE:FF'],
            options: [],
          },
        ],
        { status: 200 },
      );
    case 'get active leases':
      return HttpResponse.json(
        [{ ip: '192.168.1.110', mac: 'AA:11:22:33:44:55', ttl: 1200 }],
        { status: 200 },
      );
    default: {
      const ext = dhcpExtendedBlock(access, command);
      if (ext) return ext;
      return HttpResponse.json(
        { error: 'not implemented', msg: `Mock missing for dhcp:${command}` },
        { status: 400 },
      );
    }
  }
}
